import { Link } from "@inertiajs/react";
import { ArrowRight, Zap } from "lucide-react";
import { trackEvent } from "../../../utils/analytics";

const VoteButton = ({ location }: { location: string }) => {
  const handleClick = () => {
    trackEvent({
      name: "select_content",
      params: {
        category: "Trophées 2026",
        action: "Click",
        label: `Voter maintenant — ${location}`,
        event_name: "trophies_vote_click",
        content_type: "trophies_vote_cta",
      },
    });
  };

  return (
    <Link href="/reviews/new" className="tro-btn" onClick={handleClick}>
      <Zap aria-hidden="true" />
      Voter maintenant
      <ArrowRight aria-hidden="true" />
    </Link>
  );
};

export default VoteButton;
